class QuickView extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.querySelectorAll('[data-quick-view-trigger]').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                const targetQuickView = trigger.getAttribute('data-quick-view-trigger');
                const quickViewContainer = this.querySelector(`[data-quick-view-container="${targetQuickView}"]`);

                if (quickViewContainer) {
                    quickViewContainer.classList.add('quick-view-active');
                    quickViewContainer.setAttribute('aria-hidden', 'false');
                    document.body.classList.add("!overflow-hidden");
                } else {
                    console.error("Quick view container not found:", targetQuickView);
                }
            });
        });

        this.querySelectorAll('[data-quick-view-close]').forEach(closeTrigger => {
            closeTrigger.addEventListener('click', (e) => {
                const quickViewContainer = closeTrigger.closest('.quick-view-container');
                
                if (quickViewContainer) {
                    quickViewContainer.classList.remove('quick-view-active');
                    quickViewContainer.setAttribute('aria-hidden', 'true');
                    document.body.classList.remove("!overflow-hidden");
                }
            });
        });

        this.querySelectorAll('[data-quick-view-atc-close]').forEach(closeTrigger => {
            closeTrigger.addEventListener('click', (e) => {
                const quickViewContainer = closeTrigger.closest('.quick-view-container');
                
                if (quickViewContainer) {
                    setTimeout(() => {
                        quickViewContainer.classList.remove('quick-view-active');
                        quickViewContainer.setAttribute('aria-hidden', 'true');
                        document.body.classList.remove("!overflow-hidden");
                    }, 1000);
                }
            });
        });
    }
}

customElements.define('quick-view', QuickView);